import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { easeOut } from "../../motion/transitions";

function BottomSheet({ open, onClose, title, children, footer }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <AnimatePresence>
      {open && (
        <>
          <motion.button
            key="bottom-sheet-backdrop"
            type="button"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[1000] bg-black/40"
            onClick={onClose}
            aria-label="Fermer"
          />
          <motion.div
            key="bottom-sheet-panel"
            variants={{
              hidden: { y: "100%" },
              visible: {
                y: 0,
                transition: { duration: 0.3, ease: easeOut },
              },
              exit: {
                y: "100%",
                transition: { duration: 0.25, ease: easeOut },
              },
            }}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="fixed inset-x-0 bottom-0 z-[1001] flex max-h-[85vh] flex-col rounded-t-2xl bg-white shadow-[0_-4px_24px_rgba(0,0,0,0.12)]"
          >
            <div className="flex shrink-0 items-center justify-between border-b border-greyLight/40 px-5 py-4">
              <h2 className="font-josefin text-sm font-bold uppercase tracking-wider text-modalTitle">
                {title}
              </h2>
              <button
                type="button"
                onClick={onClose}
                className="flex h-8 w-8 items-center justify-center rounded-md text-secondaryText transition hover:bg-black/[0.04]"
                aria-label="Fermer"
              >
                <X size={18} />
              </button>
            </div>

            <div className="modal-scroll min-h-0 flex-1 px-5 py-5">
              <div className="modal-scroll-content">{children}</div>
            </div>

            {footer && (
              <div className="shrink-0 border-t border-greyLight/40 px-5 py-4">{footer}</div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body
  );
}

export default BottomSheet;
